/**
 * SharePoint Stream embeds dispose their player on pagehide, so a page restored
 * from the back/forward cache shows a dead (black) iframe. Reload those embeds.
 */
(function () {
  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) {
      return;
    }

    document.querySelectorAll('iframe[src*="/_layouts/15/embed.aspx"]').forEach((iframe) => {
      const { src } = iframe;
      iframe.src = "about:blank";
      iframe.src = src;
    });
  });
})();
